var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"richEditor-container",class:{
  'isHighLight':_vm.isHighLight && _vm.isInlineEdit,
  'inline':_vm.isInlineEdit
  },style:({
    '--bg-color': 'red'
  })},[_c('div',{staticClass:"editorWrapper",attrs:{"id":'editor-' + _vm.id}})])}
var staticRenderFns = []

export { render, staticRenderFns }